/**
 * useAuth — hook that exposes the auth context.
 *
 * Usage:
 *   const { login, logout, register, user, isAuthenticated, isLoading, apiFetch } = useAuth();
 */

import { useContext } from 'react';
import { AuthContext } from './authContext';

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return ctx;
}
